 (function () {
  'use strict';

  if (window.FellinoraFrischfutterCompareLoaded) {
    return;
  }

  window.FellinoraFrischfutterCompareLoaded = true;

  var sections = new Set();
  var states = new WeakMap();
  var ticking = false;

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function applySplit(section, value, syncRange) {
    var split = clamp(value, 0, 100);
    section.style.setProperty('--ffc-split', split + '%');

    if (syncRange) {
      var range = section.querySelector('[data-ffc-range]');
      if (range) {
        range.value = String(Math.round(split));
      }
    }
  }

  function updateScrollReveal() {
    ticking = false;

    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
    if (!viewportHeight) {
      return;
    }

    sections.forEach(function (section) {
      if (!section.isConnected) {
        sections.delete(section);
        states.delete(section);
        return;
      }

      var state = states.get(section);
      if (!state) {
        return;
      }

      var rect = section.getBoundingClientRect();
      var start = viewportHeight * 0.82;
      var end = viewportHeight * 0.2;
      var total = rect.height + start - end;
      var progress = total > 0 ? (start - rect.top) / total : 0;
      var autoValue = clamp(progress, 0, 1) * 100;

      state.autoValue = autoValue;
      applySplit(section, autoValue + state.manualOffset, true);
    });
  }

  function requestScrollReveal() {
    if (ticking) {
      return;
    }

    ticking = true;
    window.requestAnimationFrame(updateScrollReveal);
  }

  function bindSection(section) {
    if (!section || section.dataset.ffcInitialized === 'true') {
      return;
    }

    var range = section.querySelector('[data-ffc-range]');
    if (!range) {
      section.dataset.ffcInitialized = 'true';
      return;
    }

    section.dataset.ffcInitialized = 'true';

    var parsedStartValue = parseFloat(range.value);
    var startValue = clamp(Number.isFinite(parsedStartValue) ? parsedStartValue : 50, 0, 100);
    states.set(section, {
      startValue: startValue,
      autoValue: startValue,
      manualOffset: 0
    });
    sections.add(section);

    var update = function () {
      var state = states.get(section);
      if (!state) {
        return;
      }

      var parsedValue = parseFloat(range.value);
      var currentValue = clamp(Number.isFinite(parsedValue) ? parsedValue : state.startValue, 0, 100);
      state.manualOffset = currentValue - state.autoValue;
      applySplit(section, currentValue, false);
    };

    range.addEventListener('input', update, { passive: true });
    range.addEventListener('change', update, { passive: true });
    requestScrollReveal();
  }

  function initAll() {
    document.querySelectorAll('[data-ffc-section]').forEach(bindSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  window.addEventListener('scroll', requestScrollReveal, { passive: true });
  window.addEventListener('resize', requestScrollReveal, { passive: true });
  window.addEventListener('load', requestScrollReveal, { once: true });

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.matches && event.target.matches('[data-ffc-section]')
      ? event.target
      : event.target.querySelector('[data-ffc-section]');
    bindSection(section);
  });
})();